import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

const STRIPE_DASHBOARD_URL = "https://dashboard.stripe.com/";

export default function MyStripeDashboard() {
  return (
    <section aria-labelledby="stripe-dashboard-heading" className="bg-bookish-cream text-bookish-purple rounded-2xl border border-bookish-purple/15 px-4 py-6 sm:px-6 sm:py-10">
      <div className="max-w-xl mx-auto bg-white shadow-sm rounded-xl p-5 sm:p-8 border border-bookish-purple/10">
        <h1 id="stripe-dashboard-heading" className="font-serif text-2xl sm:text-3xl font-semibold mb-4">
          My Stripe Dashboard
        </h1>
        <p className="text-bookish-purple/80 mb-6 leading-relaxed">
          Follow the payments behind your stories. Open Stripe to review payments,
          payouts, and transaction history processed through your Stripe account.
          Sales handled by other retailers will not appear here.
        </p>
        <a
          href={STRIPE_DASHBOARD_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-describedby="stripe-dashboard-help"
          className="inline-flex w-full sm:w-auto min-h-[44px] items-center justify-center gap-2 bg-bookish-royal text-white px-5 py-3 rounded-full font-medium text-center shadow-sm hover:bg-bookish-purpleAccent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bookish-purple focus-visible:ring-offset-2"
        >
          <span>Open Stripe Dashboard <span className="sr-only">(opens in a new tab)</span></span>
          <ExternalLink size={18} aria-hidden="true" className="shrink-0" />
        </a>
        <p id="stripe-dashboard-help" className="mt-4 text-sm text-bookish-purple/80 leading-relaxed">
          Opens in a new tab. Sign in to Stripe if asked. If you manage more than
          one Stripe account, select the account connected to Bookish Circle.
        </p>
        <div className="mt-6 pt-5 border-t border-bookish-purple/15 space-y-2">
          <p className="text-sm">Need to connect payments or check your setup?</p>
          <Link to="/authorportal/stripeonboarding" className="inline-block min-h-[44px] py-3 underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bookish-purple focus-visible:ring-offset-2 rounded">
            Check my payment connection
          </Link>
          <p className="text-sm text-bookish-purple/80">
            Your Author membership is managed separately in the Membership &amp; Billing tab.
          </p>
        </div>
      </div>
    </section>
  );
}
